import React, { useEffect, useState } from "react";
import "./Template_3.css";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import DefaultData from "../../CompanyData/DefaultData";

const Template_3_Destinations = () => {
  const [destinations, setDestinations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const companyId = DefaultData.DEFAULTCOMPANYID;

  const defaultImages = {
    "ANDAMAN & NICOBAR ISLANDS":
      "https://images.unsplash.com/photo-1561607381-3f0aee9153e1?auto=format&fit=crop&w=800&q=80",
    SHILLONG:
      "https://images.unsplash.com/photo-1579781404557-4b4d1e5d2c1a?auto=format&fit=crop&w=800&q=80",
    LADAKH:
      "https://images.unsplash.com/photo-1593975395647-61a1b7a09b1f?auto=format&fit=crop&w=800&q=80",
    MEGALAYA:
      "https://images.unsplash.com/photo-1593601139938-6b1c6dbf2d5a?auto=format&fit=crop&w=800&q=80",
    MEGHALAYA:
      "https://images.unsplash.com/photo-1593601139938-6b1c6dbf2d5a?auto=format&fit=crop&w=800&q=80",
    MALDIVES:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=800&q=80",
    DUBAI:
      "https://images.unsplash.com/photo-1568674371763-d2a3b55a1d14?auto=format&fit=crop&w=800&q=80",
    OOTY: "https://images.unsplash.com/photo-1582129878615-71f52f2175ed?auto=format&fit=crop&w=800&q=80",
  };

  const getDefaultImage = (name) => {
    if (!name) return "";
    return defaultImages[name.trim().toUpperCase()] || "";
  };

  useEffect(() => {
    const getDestinations = async () => {
      if (!companyId) return;
      setIsLoading(true);
      try {
        const response = await apiService.getAll(
          `${config.GETALLDESTINATIONS}?companyId=${companyId}`
        );
        setDestinations(response || []);
      } catch (error) {
        console.error("Failed to fetch destinations:", error);
      } finally {
        setIsLoading(false);
      }
    };
    getDestinations();
  }, [companyId]);

  return (
    <section className="Template_3 section Template_3 destinations">
      <div className="Template_3 container">
        <div className="Template_3 section-title">
          <h2>Signature Destinations</h2>
          <p>Curated selection of the world's finest locales</p>
        </div>

        {isLoading ? (
          <p>Preparing destinations...</p>
        ) : (
          <div className="Template_3 destinations-carousel">
            {destinations.length > 0 ? (
              destinations.slice(0, 8).map((destination, index) => {
                const name = destination.destinationName || destination.Name;
                const packageCount =
                  destination.packageCount || destination.PackageCount || 0;
                const imageUrl =
                  getDefaultImage(name) ||
                  destination.imageUrl ||
                  destination.Image;

                return (
                  <div key={index} className="Template_3 destination-item">
                    <img src={imageUrl} alt={name} />
                    <div className="Template_3 destination-info">
                      <h3>{name}</h3>
                      <p>{packageCount} Exclusive Packages</p>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No destinations currently available.</p>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default Template_3_Destinations;
